import { render, staticRenderFns } from "./CampaignsCharges.vue?vue&type=template&id=347ba796"
import script from "./CampaignsCharges.vue?vue&type=script&lang=js"
export * from "./CampaignsCharges.vue?vue&type=script&lang=js"
import style0 from "./CampaignsCharges.vue?vue&type=style&index=0&id=347ba796&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/latinad/panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('347ba796')) {
      api.createRecord('347ba796', component.options)
    } else {
      api.reload('347ba796', component.options)
    }
    module.hot.accept("./CampaignsCharges.vue?vue&type=template&id=347ba796", function () {
      api.rerender('347ba796', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CampaignsCharges.vue"
export default component.exports